<template>
  <div class="app-sim-order-wrapper">
    <!--     <slot name="txtModalBody">
      <div class="option-boxes">
        <div class="option-image" :class="{ 'highlight-option': selectedSimType === SimTypes.simCardCode }">
          <slot name="optionImage"></slot>
        </div>
        <div v-if="showEsim" class="option-esim" :class="{ 'highlight-option': selectedSimType === SimTypes.eSimCode }">
          <span>eSIM</span>
        </div>
        <div class="option-price">
          <span>{{ substituteSimCardOptions_.price }} €</span>
          <slot name="txtAfterPrice"></slot>
        </div>
      </div>
    </slot> -->

    <div class="container-box">
      <div class="content-limiter">
        <slot name="txtBefore"></slot>
        <form class="">
          <div class="input-field">
            <div class="radio-group">
              <label>
                <input id="selectSimCard" type="radio" name="simType" v-model="simtype_" :value="SimTypes.simCardCode" />
                <span class="custom-radio"></span>
                <span class="text-sm">Klassische SIM-Karte (0.00 € inkl. Versand)</span>
              </label>
              <label>
                <input disabled id="selectESim" type="radio" name="simType" v-model="simtype_" :value="SimTypes.eSimCode" />
                <span class="custom-radio"></span>
                <span class="text-sm text-muted">eSIM-Karte</span>
              </label>
            </div>
          </div>
        </form>

        <div class="info-box">
          <div class="flex-align-center">
            <span class="icon" aria-hidden="true"></span>
            <span class="text-base-semibold"> eSIM Ersatz-Karten Bestellung</span>
          </div>

          <p class="text-sm">
            Die eSIM Ersatz-Karten Bestellung steht vorübergehend nur über das Service Center zur Verfügung. <br />
            Wünschst du eine eSIM, so kontaktiere uns bitte wie folgt:
          </p>

          <p class="text-sm">
            <a href="tel:+4921127742774">0211-2774 2774¹</a> oder <a href="tel:+491722222022">0172 222 20 22²</a>
          </p>

          <p class="text-sm">
            Als LIDL Connect Kunde nutzt du deine Inklusiveinheiten, wenn vorhanden. Andernfalls zahlst du in Deutschland 0.09 €
            pro Minute.
          </p>

          <p class="text-xs">
            ¹Es gilt der vom jeweiligen Anbieter ausgewiesene Preis für einen Anruf ins deutsche Festnetz. ²Aus Fremdnetzen gilt
            der vom jeweiligen Anbieter ausgewiesene Preis für einen Mobilfunkanruf ins dt. Vodafone-Netz.
          </p>
        </div>
      </div>
    </div>

    <div class="container-box">
      <div class="">
        <CustomerAddress :process-name="'simOrder'" v-if="selectedSimType === SimTypes.simCardCode">
          <template v-for="slot in possibleChildSlotsFor('Address')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </CustomerAddress>
      </div>
    </div>
    <!--     <slot name="txtSimCardBetween" v-if="selectedSimType === SimTypes.simCardCode"></slot>
    <slot name="txtESimBetween" v-if="selectedSimType === SimTypes.eSimCode"></slot>
    <div class="row p-4" v-if="selectedSimType === SimTypes.eSimCode">
      <slot name="txtDeviceCheck">
        <p>
          <strong>Ist dein Gerät eSIM-fähig? <span class="link" @click="toggleText">Prüfe es hier!</span></strong>
        </p>
      </slot>
    </div>
    <ESimDeviceCheck v-if="showDeviceCheckText"></ESimDeviceCheck>
    <div class="row p-4" v-if="selectedSimType === SimTypes.eSimCode">
      <span>E-Mail-Adresse: {{ currentCustomer.email }} </span>
    </div> -->

    <div class="container-box">
      <div class="">
        <h2 class="text-3xl justify-space-between">
          <span>Gesamtsumme</span>
          <span>{{ substituteSimCardOptions_.price }} €</span>
        </h2>
      </div>
    </div>
    <slot name="txtAfter"></slot>
    <dyn-slot :slot-data="slotData">
      <slot name="txtCostInfo"></slot>
    </dyn-slot>
    <div class="row app-stepper">
      <button :disabled="loading" @click="back()" class="button button--secondary text-sm ">Zurück</button>
      <button :disabled="loading" @click="next()" class="button button--primary">Jetzt kostenlos bestellen</button>
    </div>
  </div>
</template>

<script>
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import CustomerAddress from './Address.vue'
import { SimTypes } from '@/helper/SimTypes'
import syncProperty from '@/mixins/syncProperty'
// import ESimDeviceCheck from '@/components/process/LIDL/SimCard/ESimDeviceCheck/ESimDeviceCheck.vue'

export default {
  name: 'SimOrderWrapper',
  components: { CustomerAddress }, // ESimDeviceCheck
  mixins: [transaction('simOrder'), slotProxy(), syncProperty('simtype', 'simtype_')],
  methods: {
    next() {
      this.$emit('next', this.substituteSimCardOptions_.productNumber)
    },
    back() {
      history.back()
    },
    toggleText() {
      this.showDeviceCheckText = !this.showDeviceCheckText
    }
  },
  data() {
    return {
      substituteSimCardOptions: [{ price: '', type: SimTypes.simCardCode }],
      SimTypes,
      showDeviceCheckText: false,
      currentCustomer: {
        email: ''
      }
    }
  },
  slotData: {
    type: Object
  },
  computed: {
    substituteSimCardOptions_() {
      let selectedOptions = null

      if (this.substituteSimCardOptions.length > 0) {
        for (const options of this.substituteSimCardOptions) {
          if (options.type === this.simtype_) {
            selectedOptions = options
            break
          }
        }
      }

      return selectedOptions
    },
    slotData() {
      return this.substituteSimCardOptions_
    },
    selectedSimType() {
      return this.simtype_
    }
  },
  apollo: {
    substituteSimCardOptions: function() {
      return wrapQuery(
        gql`
          query simOrder {
            substituteSimCardOptions {
              name
              price
              productNumber
              type
              possibleActivationSettings
              productPrice
              shippingCosts
              total
            }
            currentCustomer {
              email
            }
          }
        `,
        this,
        ['substituteSimCardOptions', 'currentCustomer'],
        {},
        null,
        {
          fetchPolicy: 'cache-first'
        }
      )
    }
  },
  props: {
    showEsim: {
      type: Boolean,
      default: false
    },
    loading: { type: Boolean, default: false }
  }
}
</script>
